import React, { Component } from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import PatientCard from '../../../_components/Cards/PatientCard';
import DownloadLink from '../List/Components/DownloadLink';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getFormById } from '../../../_actions/form.actions';
import { formConstants } from '../../../_constants/form.constants';
import { Button, Spinner } from 'react-bootstrap';
import { ConsentFullName } from '../../../_helpers/licensed-professional-name';

import { Can } from '../../../_contexts/AbilitiesContext'

class View extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      currentTab: "questions",
    }
  }

  componentDidMount() {
    this.props.dispatch(getFormById(this.props.match.params.id));
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.form) !== JSON.stringify(this.props.form)) {
      this.parseResponse(this.props.form);
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: formConstants.FORMS_RETRIEVE_INIT })
  }

  parseResponse(form) {
    const data = form.questionnaire.resource.item.map(question => {
      let answers = [];
      const answered = form.questionnaireResponse.resource.item.find(item => question.definition === item.definition);

      if (answered) {
        answered.answer.forEach(answer => {
          for (let valueType in answer) {
            if (valueType === 'valueBoolean') {
              answers.push(answer.valueBoolean === true ? 'Yes' : 'No');
            } else if (valueType === 'valueDate') {
              if (answer.valueDate !== null) {
                answers.push(moment(answer.valueDate).format('MM/DD/YYYY'))
              }
            } else if (valueType === 'valueString') {
              if (answer.valueString) {
                answers.push(answer.valueString);
              }
            } else if (valueType === 'valueAttachment') {
              if (answer.valueAttachment !== null) {
                answers.push(answer.valueAttachment);
              }
            } else if (answer[valueType] !== null) {
              answers.push(answer[valueType]);
            }
          }
        });
      }

      const questionData = {
        text: question.text,
        type: question.type,
        answers: answers.length ? answers : false
      }

      if (question.type === 'display') {
        questionData.links = []
        questionData.images = []

        question.extension.forEach((item) => {
          if (item.url.includes('supportLink')) {
            questionData.links.push(item.valueUri)
          } else if (item.url.includes('supportImage')) {
            questionData.images.push(item.valueUri)
          }
        })
      }

      return questionData
    });
    this.setState({ data });
  }

  selectTab(tab) {
    this.setState({ currentTab: tab });
  }

  render() {
    const { isRetrieving, form } = this.props;

    const columns = [
      {
        name: 'Question',
        sortable: false,
        cell: question => {
          return <strong>{question.text}</strong>
        }
      },
      {
        name: 'Answer',
        sortable: false,
        cell: question => {
          if (question.type === 'display') {
            return (
              <div className='row'>
                <div className='col-12'>
                  {question.images.length === 0 && question.links.length === 0 && (
                    <span className='text-success text-uppercase'>viewed</span>
                  )}
                  {question.images.length > 0 &&
                    question.images.map((src, i) => {
                      return (
                        <div key={i} className='row my-3'>
                          <a
                            href='!#'
                            onClick={(e) => {
                              e.preventDefault()
                              window.open(src, '_blank')
                            }}
                            rel='noopener noreferrer'
                            target='_blank'
                          >
                            <img
                              src={src}
                              className='col-8 offset-2 img-thumbnail mr-1'
                              alt=''
                            />
                          </a>
                        </div>
                      )
                    })}
                  {question.links.length > 0 &&
                    question.links.map((link, i) => {
                      return (
                        <div key={i} className='row my-3'>
                          <Button
                            onClick={() => {
                              window.open(link, '_blank')
                            }}
                            rel='noopener noreferrer'
                            target='_blank'
                            variant='outline-primary'
                            className='col-8 offset-2'
                          > Click link to review
                          </Button>
                        </div>
                      )
                    })}
                </div>
              </div>
            )
          }
          if (!question.answers) {
            return <span className="text-warning text-uppercase">unanswered</span>;
          }
          if (question.type === 'attachment') {
            return question.answers.map((link, i) => {
              return <a key={i} href={link} target="_blank" rel="noopener noreferrer">
                <img
                  key={i}
                  src={link}
                  width="100px" className="img-thumbnail mr-1" alt="Upload" />
              </a>
            })
          } else {
            return question.answers.join(', ');
          }
        }
      }
    ]

    if (isRetrieving) {
      return <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>;
    }
    return <div className="container-fluid">

      <div className="row">
        <div className='col-md-3 col-lg-2'>
          <PatientCard
            email={form.userProfile.emailAddress}
            gender={form.userProfile.gender}
            lastName={form.userProfile.lastName}
            firstName={form.userProfile.firstName}
            profileId={form.userProfile.id}
            profileUrl={form.userProfile.profile}
            dateOfBirth={form.userProfile.dateOfBirth}
            phoneNumber={form.userProfile.phoneNumber}
          >
            <Can I="send" a="messages">
              <br />
              <Link
                to={{
                  state: { patientId: form.patientProfileId },
                  pathname: `/messages/view`,
                }}
                className="w-100 btn block btn-sm btn-primary">Message Patient</Link>
              </Can>
          </PatientCard>
        </div>

        <main role="main" className="col-md-9 col-lg-10 ml-sm-auto">
          <div className="row">
            <div className="col-3">
              <b>{form.questionnaire.resource.title}</b>
            </div>
            <div className="col-4 text-right">
              <b>Provider:</b> {ConsentFullName(form.doctor)}
            </div>
            <div className="col-5 text-right">
              <span className='badge badge-info text-uppercase px-4 mr-2'>{form.status}</span>
            </div>
          </div>

          {/* Questionnaire */}
          <div className='row'>
            <div className="col-12 mt-3">
              <div className="card axs-shadow">
                <div className="card-body">

                  {/* Tabs */}
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item">
                      <a
                        href="/"
                        onClick={(e) => { e.preventDefault(); this.selectTab('questions') }}
                        className={`nav-link ${this.state.currentTab === 'questions' ? 'active' : ''}`}>Questions</a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/"
                        onClick={(e) => { e.preventDefault(); this.selectTab('hpi') }}
                        className={`nav-link ${this.state.currentTab === 'hpi' ? 'active' : ''}`}>HPI</a>
                    </li>
                    <li className="col nav-item pr-0">
                      <div className="w-25 ml-auto">
                        <DownloadLink small block form={form} icon={false} />
                      </div>
                    </li>
                  </ul>

                  {/* Tab Content */}
                  <div className="tab-content">
                    <div className={`tab-pane show ${this.state.currentTab === 'questions' ? 'active' : ''}`} role="tabpanel" aria-labelledby="questions-tab">
                      <DataTable
                        noHeader
                        noTableHead
                        columns={columns}
                        data={this.state.data}
                        customStyles={{ cells: { style: { fontSize: '14px', paddingTop: '1em', paddingBottom: '1em' } } }}
                      />
                    </div>
                    <div className={`tab-pane show ${this.state.currentTab === 'hpi' ? 'active' : ''}`} role="tabpanel" aria-labelledby="hpi-tab">
                      <div className="pt-3 px-2" style={{ fontSize: "1em" }}>
                        {this.props.form.questionnaireResponse.hpi || <div className='text-center'>No HPI Available</div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  }
}

const mapStateToProps = state => {
  return {
    isRetrieving: state.form.isRetrieving,
    form: state.form.details
  }
}

export default connect(mapStateToProps)(View);